import type { Dispatch } from 'react';
import { ClientCacheAction, ClientCacheStateType } from '../context';
import { SET_CLIENT_CACHE } from './actionTypes';

export const setClientCache = async (
  clientCache: ClientCacheStateType['clientCache'],
  dispatch: Dispatch<ClientCacheAction>,
) => {
  dispatch({
    type: SET_CLIENT_CACHE,
    payload: clientCache,
  });
};
